import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export const CategoryFilter = ({ selectedCategory, onCategoryChange }: CategoryFilterProps) => {
  const categories = [
    { value: "all", label: "All" },
    { value: "general", label: "General" },
    { value: "gratitude", label: "Gratitude" },
    { value: "support", label: "Support" },
    { value: "encouragement", label: "Encouragement" }
  ];

  return (
    <div className="relative">
      <ScrollArea className="w-full whitespace-nowrap rounded-md">
        <div className="flex space-x-2 p-2">
          {categories.map((category) => (
            <Button
              key={category.value}
              variant={selectedCategory === category.value ? "default" : "outline"}
              size="sm"
              onClick={() => onCategoryChange(category.value)}
              className={`
                min-w-[80px] h-7 rounded-full text-xs transition-all
                ${selectedCategory === category.value 
                  ? 'bg-emerald-500 hover:bg-emerald-600 text-white shadow-sm' 
                  : 'hover:bg-emerald-50 dark:hover:bg-emerald-900'}
              `}
            >
              {category.label}
            </Button>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
};